/**
 * Copyright (c) 2023 Google LLC
 * SPDX-License-Identifier: MIT
 */

export const availableLocales = [
  'cs-CZ',
  'da-DK',
  'de-DE',
  'en',
  'es-ES',
  'fi-FI',
  'fr-CA',
  'fr-FR',
  'he-IL',
  'hi-IN',
  'it-IT',
  'ja-JP',
  'ko-KR',
  'lt-LT',
  'nb-NO',
  'nl-NL',
  'pl-PL',
  'pt-BR',
  'pt-PT',
  'ru-RU',
  'sv-SE',
  'th-TH',
  'tr-TR',
  'uk-UA',
  'zh-CN',
  'zh-TW',
];
